import { render, staticRenderFns } from "./featureManagement.vue?vue&type=template&id=f4eee48e&scoped=true"
import script from "./featureManagement.vue?vue&type=script&lang=js"
export * from "./featureManagement.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./featureManagement.vue?vue&type=style&index=1&id=f4eee48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eee48e",
  null
  
)

export default component.exports